module.exports = "\nmutation MutationCleanMessageParselyMyTeam($token: String!, $code: String!) {\n    cleanMessage(token: $token, code: $code)\n}\n"